// extracted by mini-css-extract-plugin
module.exports = {"label":"_1KCaE","medium":"_7V7KH","left":"_2ebmn","top":"_3Tpp2","small":"_1dY3d","xs":"_jubjB"};